import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './student-passes';
import './student-grades';

/**
 * Irish Dance — student-profile tab (admin/teacher view). Hosts the competition-passes
 * matrix and the grade-exams list (CADENCE_SPEC §30.1). Teacher view = this same tab,
 * permission-gated (read-only without students.edit).
 */
@customElement('cadence-irish-dance-student-tab')
export class IrishDanceStudentTab extends LitElement {
  @property() studentId = '';

  static styles = css`
    :host { display: block; }
    /* Single-column grid: minmax(0,1fr) caps the track at the container width so a wide
       child (e.g. a table) can't stretch the panel and force page-level horizontal scroll. */
    .panel { margin-top: var(--space-4); display: grid; grid-template-columns: minmax(0, 1fr); gap: var(--space-4); }
  `;

  render() {
    return html`
      <div class="panel">
        <cadence-irish-dance-passes .studentId=${this.studentId}></cadence-irish-dance-passes>
        <cadence-irish-dance-grades .studentId=${this.studentId}></cadence-irish-dance-grades>
      </div>
    `;
  }
}
